import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { API } from '../utils/Api';

export const usePatientsQuery = (
    clientId: string|undefined,
    filters: [string, string][],
    limit: number,
    offset: number,
    sort: [string,number][]
) => {
    return useQuery({
        queryKey: ['patients', clientId, filters, limit, offset, sort],
        queryFn: async () => {
            const { items: patients, count: numPats } = await API.getPatients(
                clientId||'',
                filters,
                limit,
                offset,
                sort
            );
            return { patients, numPats };
        },
        placeholderData: keepPreviousData,
        staleTime:30000,
        enabled:!!clientId
    });
};